<script lang="ts">
  import FilterMenu from "components/Filter/FilterMenu.svelte";
  import { resetFilters, searchFilter, searchParams } from "state/page";
  import { orgClose, orgFilter } from "@nrk/origo";
  import { onMount } from "svelte";
  import { client } from "responsivity/breakpoints";
  import ProductionsMenu from "./Folders/ProductionsMenu.svelte";
  import { isPlugin } from "state/app";

  type SideMenuState = "filters" | undefined;

  export let sideMenuState: SideMenuState = undefined;

  $: hasActiveFilters =
    Object.values($searchFilter).some((filter) => {
      if (Array.isArray(filter)) return filter.length > 0;
      return !!filter;
    }) || !!$searchParams.owner;

  onMount(() => {
    sideMenuState = isPlugin
      ? "filters"
      : hasActiveFilters && !client.isSmallMobile(clientWidth)
        ? "filters"
        : undefined;
  });

  $: sideMenuClosed = sideMenuState === undefined;

  let clientWidth;
</script>

<svelte:window bind:innerWidth={clientWidth} />
<div class="wrapper" class:sideMenuClosed>
  {#if sideMenuState === "filters"}
    <div class="header">
      <div class="header-title">
        <button
          type="button"
          class="org-button org-button--secondary container-expand"
          title="Filtrer resultater"
          aria-controls="filter-container"
          aria-pressed={sideMenuState === "filters"}
          on:click={() => (sideMenuState = undefined)}
        >
          {@html orgFilter}
        </button>
        <span>Filtrer resultater</span>
      </div>
      <button
        type="button"
        class="org-button close-button"
        title="Lukk filtermenyen"
        aria-label="Lukk filtermenyen"
        on:click={() => (sideMenuState = undefined)}
      >
        {@html orgClose}
      </button>
    </div>

    <FilterMenu></FilterMenu>
    <ProductionsMenu></ProductionsMenu>

    {#if client.isSmallMobile(clientWidth)}
      <div class="action-buttons">
        <button
          type="button"
          class="org-button org-button--primary"
          on:click={() => (sideMenuState = undefined)}
        >
          Vis resultater
        </button>
        <button type="button" class="org-button org-button--secondary" on:click={resetFilters}>
          Nullstill
        </button>
      </div>
    {/if}
  {/if}
</div>

<style>
  .wrapper {
    position: sticky;
    padding: var(--org-xsmall) var(--org-xsmall) 0;
    background: var(--color-surface-secondary);
    width: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    transition: width 0.5s;
    top: 0px;
    z-index: 2;
    display: flex;
    flex-direction: column;
  }

  .sideMenuClosed {
    width: 0;
    transition: width 0.2s ease-in-out;
    padding: 0;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: start;
    align-content: start;
    white-space: nowrap;
  }

  .header-title {
    display: flex;
    align-items: center;
    gap: var(--org-xsmall);
  }

  .header-title span {
    font-weight: 700;
  }

  .container-expand[aria-pressed="true"] {
    background-color: var(--org-color-shade-1);
    border-bottom: solid 1px var(--org-color-primary, #1769ff);
  }

  .action-buttons {
    position: sticky;
    bottom: 0;
    margin-top: auto;
    display: flex;
    flex-direction: column;
    gap: var(--org-xsmall);
    padding: var(--org-xsmall);
    background: var(--color-surface-secondary);
  }

  .action-buttons .org-button {
    flex: 1;
  }

  @media screen and (max-width: 480px) {
    .wrapper:not(.sideMenuClosed) {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      z-index: 5;
    }
  }
</style>
